// QL-414 — the one currency setting every PDF block that prints money has:
// with each amount, as a note under the block, or not at all. A chart-only
// block offers the note or nothing, since a chart's axis never carries it.

export const T = {
  en_GB: {
    currency: "Currency",
    with_amounts: "With amounts",
    with_amountsHelp: "Every amount carries the currency, e.g. 60 000 EUR.",
    with_amountsChartHelp:
      "The chart prints no currency; only the table's amounts carry it, and the table is off.",
    note: "Note below table",
    noteChart: "Note below",
    noteHelp: 'Amounts print bare, with e.g. "All amounts in EUR" under the block.',
    off: "Off",
    offHelp: "No currency is printed.",
  },
  nb_NO: {
    currency: "Valuta",
    with_amounts: "Med beløpene",
    with_amountsHelp: "Hvert beløp vises med valuta, f.eks. 60 000 EUR.",
    with_amountsChartHelp:
      "Diagrammet viser ingen valuta; bare beløpene i tabellen får den, og tabellen er av.",
    note: "Merknad under tabellen",
    noteChart: "Merknad under",
    noteHelp: "Beløpene vises uten valuta, med f.eks. «Alle beløp i EUR» under blokken.",
    off: "Av",
    offHelp: "Ingen valuta vises.",
  },
} as const;
